// src/components/ads/SubcategoryInlineAd.js
import AdSlot from "../AdSlot";

export default function SubcategoryInlineAd() {
  return (
    <AdSlot
      slot="2729446592"
      className="my-8"
      style={{ minHeight: "100px" }}
    />
  );
}